export enum ChartColors {
  '#FFE5CC' = 'LIGHT_ORANGE',
  '#FF7F00' = 'ORANGE',
  '#CC2A16' = 'RED',
  '#30819F' = 'BLUE',
  '#0D8C8C' = 'GREEN',
  '#F5CE3C' = 'YELLOW',
}
